import React from "react";
import { connect } from 'react-redux'
import { Row, Col, Image } from 'react-bootstrap';

import './QuoteItem.css';

const add = (itemName) => ({
  type: 'ADD',
  itemName
})

const subtract = (itemName) => ({
  type: 'SUBTRACT',
  itemName
})


let QuoteItem = ({dispatch, name, image, description, price, count}) => {
  return (
    <Row className="quote-row">
      <Col xs={4}>
        <Image src={image} responsive/>
      </Col>
      <Col xs={8}>
        <Col xs={12} md={6} className="quote-description">
          {description}
        </Col>
        <Col xs={6} md={3}>
          <div className="quote-button" onClick={() => dispatch(add(name))}>+</div>
          {count}
          <div className="quote-button" onClick={() => dispatch(subtract(name))}>-</div>
        </Col>
        <Col xs={4} md={3}>
          ${price}
        </Col>
      </Col>
    </Row>
  );
}

QuoteItem = connect()(QuoteItem)

export default QuoteItem


// WEBPACK FOOTER //
// ./src/QuoteItem.js